import axios from "axios";

const urlPath = "log";

export const logVisitaMenu = async (menu) => {
  try {
    await axios.post(`${urlPath}/visita-menu`, { menu });
  } catch (error) {
    console.log(error);
  }
};
